import { connect } from 'react-redux';
import ConfirmDeleteModal from './shared/confirm_delete_modal.jsx';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import {
  deleteTiles 
} from 'zoomforth_codesbane_editor/action_creators/sections.grid.js';

import {
  getDisplayableTileType
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

const mapStateToProps = (state, { contentItem }) => {
  return {
    title: 'Really delete tile?',
    body: `You are about to delete this ${getDisplayableTileType(contentItem)} Tile. This cannot be undone.`,
    confirmText: 'Delete Tile',
    cancelText: 'Cancel'
  };
};


const mapDispatchToProps = (dispatch, { contentItem }) => (
  {
    onCancel: ()=> { 
      dispatch(closeModal()); 
    },
    onConfirm: ()=> { 
      dispatch(deleteTiles([contentItem]));
      dispatch(closeModal());
    }
  }
);

const ConfirmDeleteTileModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);

ConfirmDeleteTileModal.editorModalName = 'ConfirmDeleteTileModal';

export default ConfirmDeleteTileModal;
